// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"_1bARWRkA","withBorders":"_3qZRie-K","spinner":"_3EFjZFl4","noOffers":"_24g1w8EQ","emptyIcon":"_2HAkuFui"};